import { request } from '@gilbarbara/helpers';
import { apiEndPoint, headerWithAuthorization } from 'helpers';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { GetAllBranchsEndpoint, GetFacilitiesByBranch } from 'config';
import { ActionTypes } from 'literals';

import {
  branchFacilites,
  branchFacilitesFinish,
  branchSelected,
  branchsFinish,
  getFacilityAction,
  getFacilityFinishAction,
} from 'actions';
import { handleSagaAuthError } from 'sagas/helpers';
import { notify } from 'ui/notification';

export function* getBranchFacitiesSaga({ payload }: ReturnType<typeof branchFacilites>): any {
  try {
    let data: any = [];

    data = yield call(request, `${apiEndPoint(GetFacilitiesByBranch.GET)}/${payload.branchId}`, {
      method: 'GET',
      headers: headerWithAuthorization(),
    });

    yield put(branchFacilitesFinish({ data }));
  } catch (error: any) {
    if (process.env.NODE_ENV === 'development') {
      console.log('Error', error);
    }

    if (!(yield* handleSagaAuthError(error))) {
      notify.error('Can not get branch facilities!');
    }
  }
}

export function* getBranchsSaga(): any {
  try {
    let data: any = [];

    data = yield call(request, `${apiEndPoint(GetAllBranchsEndpoint.GET)}`, {
      method: 'GET',
      headers: headerWithAuthorization(),
    });

    yield put(branchsFinish({ data }));
  } catch (error: any) {
    if (process.env.NODE_ENV === 'development') {
      console.log('Error', error);
    }

    if (!(yield* handleSagaAuthError(error))) {
      notify.error('Can not get branches!');
    }
  }
}

export function* getFacilitySaga({ payload }: ReturnType<typeof getFacilityAction>): any {
  try {
    let data: any = [];

    data = yield call(
      request,
      `${apiEndPoint(GetFacilitiesByBranch.GET_FACILITY_DETAIL)}/${payload.facility_id}`,
      {
        method: 'GET',
        headers: headerWithAuthorization(),
      },
    );

    yield put(getFacilityFinishAction({ data }));
    yield put(branchSelected(data));
  } catch (error: any) {
    if (process.env.NODE_ENV === 'development') {
      console.log('Error', error);
    }

    if (!(yield* handleSagaAuthError(error))) {
      notify.error('Can not get facility info!');
    }
  }
}

export default function* root() {
  yield all([
    takeLatest(ActionTypes.GET_BRANCH, getBranchsSaga),
    takeLatest(ActionTypes.GET_BRANCH_FACILITY, getBranchFacitiesSaga),
    takeLatest(ActionTypes.GET_FACILITY, getFacilitySaga),
  ]);
}
